import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-container row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 row ms-0 me-0 ps-0 pe-0" }, null, -1)
const _hoisted_5 = { class: "col-md-4 row ms-0 me-0 ps-0 pe-0 d-flex justify-content-center align-items-center" }
const _hoisted_6 = { class: "col-md-10" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "col-md-12" }, null, -1)
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "col-md-3 row ms-0 me-0 ps-0 pe-0 d-flex justify-content-end" }
const _hoisted_14 = { class: "header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" }
const _hoisted_15 = {
  key: 0,
  class: "header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end"
}
const _hoisted_16 = {
  key: 1,
  class: "header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end"
}
const _hoisted_17 = {
  key: 2,
  class: "header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end"
}
const _hoisted_18 = { class: "header-menu col-md-2 mt-3 ps-1 pe-2 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheLogo = _resolveComponent("TheLogo")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_SpeedDial = _resolveComponent("SpeedDial")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheLogo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.isRPKUser)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    options: _ctx.legalGroups,
                    optionLabel: "name",
                    filter: "",
                    filterFields: ['name'],
                    showClear: "",
                    placeholder: _ctx.isLegalGroupLoading ? ('Loading...') : 'Legal Group',
                    loading: _ctx.isLegalGroupLoading,
                    modelValue: _ctx.filterLegalGroupModel,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterLegalGroupModel) = $event)),
                    onChange: _ctx.onLegalGroupChange
                  }, {
                    value: _withCtx((slotProps) => [
                      (slotProps.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("span", _hoisted_9, _toDisplayString(slotProps.value.name + ' and Subsidiary Companies'), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(slotProps.placeholder), 1))
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(slotProps.option.name + ' and Subsidiary Companies'), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["options", "placeholder", "loading", "modelValue", "onChange"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(_component_SpeedDial, {
                class: "speeddial",
                direction: "down",
                showIcon: "pi pi-home",
                hideIcon: "pi pi-home",
                onClick: _ctx.home
              }, null, 8, ["onClick"])
            ])), [
              [
                _directive_tooltip,
                'Home',
                void 0,
                { bottom: true }
              ]
            ]),
            (!_ctx.isApprovalPortal && (_ctx.isAdmin || _ctx.isHQStaff))
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_Button, {
                    class: "p-overlay-badge hidden-button-badge me-2 p-badge-danger",
                    badge: _ctx.totalApprovalCount != null && _ctx.totalApprovalCount != '' && _ctx.totalApprovalCount != '0' ? _ctx.totalApprovalCount : ''
                  }, null, 8, ["badge"]),
                  _createVNode(_component_SpeedDial, {
                    class: "speeddial",
                    direction: "down",
                    showIcon: "pi pi-check-square",
                    hideIcon: "pi pi-check-square",
                    onClick: _ctx.approval
                  }, null, 8, ["onClick"])
                ])), [
                  [
                    _directive_tooltip,
                    'Submission',
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (!_ctx.isAdminPortal && (_ctx.isAdmin || _ctx.isHQStaff))
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_SpeedDial, {
                    class: "speeddial",
                    direction: "down",
                    showIcon: "pi pi-users",
                    hideIcon: "pi pi-users",
                    onClick: _ctx.admin
                  }, null, 8, ["onClick"])
                ])), [
                  [
                    _directive_tooltip,
                    'Admin',
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (!_ctx.isAuditLogPortal && (_ctx.isAdmin || _ctx.isHQStaff))
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_SpeedDial, {
                    class: "speeddial",
                    direction: "down",
                    showIcon: "pi pi-pencil",
                    hideIcon: "pi pi-pencil",
                    onClick: _ctx.audit
                  }, null, 8, ["onClick"])
                ])), [
                  [
                    _directive_tooltip,
                    'Audit Log',
                    void 0,
                    { bottom: true }
                  ]
                ])
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_SpeedDial, {
                class: "speeddial",
                model: _ctx.items,
                direction: "down",
                showIcon: "pi pi-user",
                hideIcon: "pi pi-user",
                onShow: _ctx.showAccount,
                onHide: _ctx.hideAccount,
                tooltipOptions: {position: 'left'}
              }, null, 8, ["model", "onShow", "onHide"])
            ])), [
              [
                _directive_tooltip,
                {value: 'Account', disabled: _ctx.isAccountVisible},
                void 0,
                { bottom: true }
              ]
            ])
          ])
        ])
      ])
    ])
  ], 64))
}